import { render } from "./LatestTransactions.vue?vue&type=template&id=4e8e32b0&ts=true"
import script from "./LatestTransactions.vue?vue&type=script&lang=ts"
export * from "./LatestTransactions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__